import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Link, Routes, Navigate } from 'react-router-dom';
import Puzzle from './Puzzle';
import './App.css';
import Puzzles from './Puzzles';
import NewPuzzle from './NewPuzzle';
import PuzzleSolver from './PuzzleSolver';
import DailyChallengeManager from './components/DailyChallengeManager';
import VersionManager from './components/VersionManager';
import Login from './components/Login';
import { AuthProvider, useAuth } from './contexts/AuthContext';

// Navigation component that includes the header with links
const Navigation = () => {
  const { logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const handleLogout = () => {
    logout();
    closeMenu();
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className="navbar">
      <div className="nav-container">
        <nav>
          <div className="hamburger-menu" onClick={toggleMenu}>
            <div className="hamburger-icon"></div>
            <div className="hamburger-icon"></div>
            <div className="hamburger-icon"></div>
          </div>
          <ul className={menuOpen ? "show" : ""}>
            <li><Link to="/" onClick={closeMenu}>Puzzles</Link></li>
            <li><Link to="/puzzle" onClick={closeMenu}>Add Puzzle</Link></li>
            <li><Link to="/solver" onClick={closeMenu}>Puzzle Solver</Link></li>
            <li><Link to="/daily-challenges" onClick={closeMenu}>Daily Challenges</Link></li>
            <li><Link to="/version-manager" onClick={closeMenu}>Version Manager</Link></li>
            <li><button onClick={handleLogout} className="logout-button">Logout</button></li>
          </ul>
          <h1>Watson by MWG</h1>
        </nav>
      </div>
    </header>
  );
};

// Main application content with protected routes
const AppContent = () => {
  const { currentUser } = useAuth();

  // If user is not logged in, only show the login route
  if (!currentUser) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    );
  }

  // If user is logged in, show all routes with navigation
  return (
    <div>
      <Navigation />
      <Routes>
        <Route path="/login" element={<Navigate to="/" />} />
        <Route path="/puzzle" element={<NewPuzzle />} />
        <Route path="/puzzle/:boardNumber" element={<Puzzle />} />
        <Route path="/fill/puzzle" element={<Puzzle />} />
        <Route path="/" element={<Puzzles />} />
        <Route path="/solver" element={<PuzzleSolver />} />
        <Route path="/daily-challenges" element={<DailyChallengeManager />} />
        <Route path="/version-manager" element={<VersionManager />} />
      </Routes>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
};

export default App;
